import { useContext } from 'react';
import { LoginStateContext } from '../../providers/LoginStateProvider/LoginStateProvider';

export const useLoginState = () => useContext(LoginStateContext);
